module.exports = __webpack_public_path__ + "static/media/ic_bills.27f51cb3.svg";